export const isValidRegExp = (value: string): boolean => {
  try {
    RegExp(value);
    return true;
  } catch {
    return false;
  }
};
